import React, { useEffect } from 'react';
import Loader from '@tcl-boron-prefabs/loader';
import cn from 'classnames';
import withStyles from '@tempus/component-library/utils/withStyles';
import styles from '../../styles';
import qs from 'query-string';
import { handleEhrLaunch, isValidEHRQueryParams } from '../../utils/ehr-launch-utils';

function EhrLaunch({ classes }) {
  useEffect(() => {
    const query = qs.parse(window.location.search);
    if (isValidEHRQueryParams(query)) {
      handleEhrLaunch(query.launch, query.iss);
    }
  }, []);

  return (
    <div className={cn('app-view-container', classes.loadingContainer)}>
      <Loader />
    </div>
  );
}

export default withStyles(styles)(EhrLaunch);
